<div style="padding: 2em">
  <h3>Edit {{ hardware.label }}</h3>
  <div class="field-wrapper">
    <!-- Element metadata & currency-->
    <span class="sub-section-title">General details:</span>
    <ng-container *ngFor="let field of metadataFields">
      <app-field
        class="field"
        [field]="field"
        [ngClass]="field.tabGroupId"
      ></app-field>
    </ng-container>

    <!-- Share to other organizations -->
    <mat-form-field class="area-field">
      <mat-chip-grid #chipLists>
        <!-- 
          @todo: integrate this into-form-field into field component to avoid duplication.
          https://rocketfarm.atlassian.net/browse/PALLY-4042
        -->
        <mat-chip-row
          *ngFor="let org of selectedOrgs"
          (removed)="removeOrg(org)"
        >
          {{ org.name }}
          <button matChipRemove>
            <mat-icon>cancel</mat-icon>
          </button>
        </mat-chip-row>
        <input
          type="text"
          placeholder="Add organization..."
          #orgsFormInput
          [formControl]="orgSearchFormCtrl"
          [matAutocomplete]="autoOrgs"
          [matChipInputFor]="chipLists"
          [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
        />
      </mat-chip-grid>
      <mat-autocomplete
        #autoOrgs="matAutocomplete"
        (optionSelected)="setSelectedOrg($event)"
      >
        <mat-option
          *ngFor="let orgsForm of orgSearched$ | async"
          [value]="orgsForm"
        >
          {{ orgsForm.name }}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>

    <!-- Advanced settings -->
    <ng-container *ngIf="advancedFields.length">
      <mat-expansion-panel class="advanced-field-expansion-panel">
        <mat-expansion-panel-header>
          <mat-panel-title> Advanced Settings </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="advanced-field-wrapper">
          <app-field
            *ngFor="let field of advancedFields"
            class="advanced-field"
            [ngClass]="field.tabGroupId"
            [field]="field"
            [id]="field.id"
          >
          </app-field>
        </div>
      </mat-expansion-panel>
    </ng-container>
  </div>

  <button mat-stroked-button (click)="dialogRef.close()">Cancel</button>
  <button
    style="float: right; margin-left: 1em"
    color="primary"
    mat-flat-button
    (click)="saveAndClose()"
  >
    <mat-icon>save</mat-icon>
    Save changes
  </button>
</div>
